import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useBuyTracking = () => {
    const location = useLocation();
    const getCookie = (name: string): string | null => {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const item = queryParams.get('item') || queryParams.get('product_codename');
        const orderId = queryParams.get('order_id');
        const globalOrderId = queryParams.get('order_id_global');
        const price = queryParams.get('price');
        const total = queryParams.get('total');
        const country = queryParams.get('addresses_country') || queryParams.get('country');
        const email = queryParams.get('emailaddress');
        const token = queryParams.get('token');  
        const sessId2 = getCookie('sessid2');

        if (total && total !== '0') {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'purchase',
                item,
                price,
                total,
                orderId,
                globalOrderId,
                country,
                email,
                token,
                sessId2,
            });
        }
    }, [location.search]);
};

export default useBuyTracking;